import { render, staticRenderFns } from "./Updatalog.vue?vue&type=template&id=3eb809d5&scoped=true"
import script from "./Updatalog.vue?vue&type=script&lang=js"
export * from "./Updatalog.vue?vue&type=script&lang=js"
import style0 from "./Updatalog.vue?vue&type=style&index=0&id=3eb809d5&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb809d5",
  null
  
)

export default component.exports